<template>
    <BaseWidget
        :id="id"
        :widget-name="widgetName"
        :has-content="!!content"
        :is-loading="isLoading"
        :is-expanded="isExpanded"
        :configuration-data="configurationData"
        :widget-type="widgetType"
        :widget-last-updated="widgetLastUpdated"
        :needs-attention="needsAttention"
        v-on="$listeners"
    >
        <div v-show="!isLoading" class="widget-content widget-scrollable">
            <div class="widget-inner">
                <div class="widget-table-wrapper">
                    <Component
                        :is="isPrintver ? 'div' : 'Simplebar'"
                        :class="isPrintver ? '' : 'with-border-track'"
                    >
                        <table class="staff-performance-table">
                            <thead>
                                <tr>
                                    <th>{{ $t('dashboard.widgetType2.staffName') }}</th>
                                    <th>{{ $t('dashboard.widgetType2.callId') }}</th>
                                    <th>{{ $t('dashboard.widgetType2.numberOfCalls') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(performer, index) in content" :key="index">
                                    <td>
                                        <p v-for="(name, i) in sortStaffNames(performer.staff)" :key="i">
                                            <span v-if="i === 0" class="medal">{{ index + 1 }}</span>
                                            <span class="with-tooltip" :data-tooltip="name">{{ name }}</span>
                                        </p>
                                    </td>
                                    <td>{{ performer.call_id }}</td>
                                    <td>{{ performer.calls }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </Component>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script type="text/babel">
import { mapState, mapGetters } from 'vuex';
import Simplebar from 'simplebar-vue';
import orderBy from 'lodash-es/orderBy';
import BaseWidget from '../BaseWidget';
import widgetInterface from './common/widgetInterface';
import WidgetConfigurationTable from './common/WidgetConfigurationTable.vue';
import { configurationData } from './common/widgetsComputedProps';

export default {
    components: {
        BaseWidget,
        Simplebar,
        WidgetConfigurationTable,
    },

    props: widgetInterface,

    data() {
        return {
            needsAttention: false,
        };
    },

    computed: {
        ...mapGetters('user', ['userType']),
        ...mapState({
            navCollapsed: 'navCollapsed',
            callTypes: 'callTypes',
            allAssignmentAreas: 'assignmentArea',
        }),

        configurationData,

        /**
         * Returns widget name
         * @returns {string}
         */
        widgetName() {
            return this.configuration.name || this.$t('dashboard.widgetType2.name');
        },
    },

    methods: {
        /**
         * Returns staffNames sorted
         * @param {string[]} staffNames
         * @returns {string[]}
         */
        sortStaffNames(staffNames) {
            return orderBy(staffNames);
        },

        setNeedsAttention(value) {
            this.needsAttention = value;
        },
    },
};
</script>
